import {
  NotificationsNoneOutlinedIcon,
  AccountBoxOutlinedIcon,
  DashboardOutlinedIcon,
  LocationOnOutlinedIcon,
  PetsOutlinedIcon,
  GroupWorkOutlinedIcon,
} from "../../icons";

export const routes = [
  {
    icon: DashboardOutlinedIcon,
    title: "dashboard",
    link: "/",
    // role: [1, 2, 3],
    role: [3],
  },
  {
    icon: LocationOnOutlinedIcon,
    title: "Location", // geofence
    link: "/map",
    // role: [1, 2, 3],
    role: [3],
  },
  {
    icon: GroupWorkOutlinedIcon,
    title: "devices",
    link: "/devices",
    // role: [1, 2, 3],
    role: [3],
  },
  {
    icon: PetsOutlinedIcon,
    title: "livestock",
    link: "/livestocks",
    // role: [1, 2, 3],
    role: [3],
  },
  {
    icon: NotificationsNoneOutlinedIcon,
    title: "alerts",
    link: "/alerts",
    // role: [1, 2, 3],
    role: [3],
  },
  {
    icon: AccountBoxOutlinedIcon,
    title: "profile",
    link: "/profile",
    // role: [1, 2, 3],
    role: [3],
  },
];
